export default __webpack_public_path__ + "static/media/conqueror_icon.903dd4cc.png";